import formModel from './formModel';
import moment from "moment";

const {
    formField: {
        situacionImpositiva,
        personaJuridica,
        codigosLocalidad,
        vigencia,
        fechaVigencia,
        descuentoExtra,
        descuentoEspecial,
        frecuenciaPago,
        cuotas,
        ajusteAutomatico,
        equipoTelematica,
        carProdSelected,
        comments,
        afinidad,
        img_afinidad,
        fechaCotizacion,
        zonaRiesgo
    }
} = formModel;

export default {
    vehiculo: {
        marca: '',
        anio: '',
        modelo: '',
        version: '',
        valorAdicional: '0',
        usoVehiculo: '2',
        ceroKm: 'false',
        tieneGnc: '0',
        valorGnc: '700000',
        sumaAsegurada: 0,
    },
    [situacionImpositiva.name]: '4',
    [personaJuridica.name]: '0',
    [codigosLocalidad.name]: '',
    [vigencia.name]: '1',
    [fechaVigencia.name]: '',
    [descuentoExtra.name]: 0,
    [descuentoEspecial.name]: 0,
    [frecuenciaPago.name]: '',
    [cuotas.name]: '',
    [ajusteAutomatico.name]: '',
    [equipoTelematica.name]: '',
    [carProdSelected.name]: '',
    [comments.name]: '',
    codigoPostal: '',
    codigoLocalidad: '',
    [afinidad.name]: '',
    [img_afinidad.name]: '',
    [fechaCotizacion.name]: moment().format('YYYY-MM-DD'),
    [zonaRiesgo.name]: "",
    sumaAseguradaFirst: 0,
};
